<template>
  <div class="expert-card">
    <div class="expert-card__photo">
      <img v-if="photo" :src="imgUrl" alt="avatar" />
      <img v-else src="../../assets/images/avatar.jpg" alt="avatar" />
    </div>
    <div class="expert-card__info">
      <div class="expert-card__name">
        {{ name }}
      </div>
      <a :href="`mailto:${email}`" class="expert-card__email">
        <Icon :icon="'email'" />
        {{ email }}
      </a>
    </div>
  </div>
</template>

<script>
import config from "../../nuxt.config";

export default {
  name: "ExpertCard",
  components: {
    Icon: () => import("../elements/Icon"),
  },
  props: {
    photo: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    email: {
      type: String,
      default: null,
    },
  },
  computed: {
    imgUrl() {
      return this.photo ? config.env.BASE_URL + this.photo : "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.expert-card {
  display: flex;
  align-items: center;
  &__photo {
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 2.4rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__name {
    font-size: 1.8rem;
    font-weight: 700;
    color: $text_gray;
  }
  &__email {
    display: flex;
    align-items: center;
    color: $red;
    font-size: 1.4rem;
    text-decoration: none;
    transition: 0.3s ease-out;
    .icon {
      margin-right: 1rem;
      width: 1.6rem;
    }
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
